export default __webpack_public_path__ + "static/keytrade-logo-a16934b14709aeacbb8fef7996e6f84b.svg";